import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function usePdfTemplates() {
  return useQuery(
    orpc.communications.pdfTemplates.list.queryOptions({ input: {} }),
  );
}

export function useCreatePdfTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.pdfTemplates.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.list.key(),
        });
      },
    }),
  );
}

export function useUpdatePdfTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.pdfTemplates.update.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.list.key(),
        });
      },
    }),
  );
}

export function useRenderPdfPreview() {
  return useMutation(
    orpc.communications.pdfTemplates.renderPreview.mutationOptions(),
  );
}

export function useDeletePdfTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.pdfTemplates.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.list.key(),
        });
      },
    }),
  );
}

export function usePdfTemplateVersions(pdfTemplateId: string) {
  return useQuery({
    ...orpc.communications.pdfTemplates.listVersions.queryOptions({
      input: {
        pdfTemplateId: pdfTemplateId || '00000000-0000-0000-0000-000000000000',
      },
    }),
    enabled: !!pdfTemplateId,
  });
}

export function useCreatePdfTemplateDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.pdfTemplates.createDraft.mutationOptions({
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.listVersions.key({
            input: { pdfTemplateId: variables.pdfTemplateId },
          }),
        });
      },
    }),
  );
}

export function useUpdatePdfTemplateDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.pdfTemplates.updateDraft.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.listVersions.key(),
        });
      },
    }),
  );
}

export function useFinalizePdfTemplateDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.pdfTemplates.finalizeDraft.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.listVersions.key(),
        });
      },
    }),
  );
}

export function usePublishPdfTemplateVersion() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.pdfTemplates.publishVersion.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.list.key(),
        });
        queryClient.invalidateQueries({
          queryKey: orpc.communications.pdfTemplates.listVersions.key(),
        });
      },
    }),
  );
}
